import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { GraphicalDataSourceNodeBase } from "abweb/dto/generated/gds/GraphicalDataSourceNodeBase";
export class GraphicalDataSourceNode extends GraphicalDataSourceNodeBase {
  constructor() {
    super();
    _defineProperty(this, "_parentNode", null);
  }
  get isTopLevelNode() {
    return this._parentNode == null || this._parentNode._parentNode == null;
  }
}
//# sourceMappingURL=GraphicalDataSourceNode.js.map
